import { useEffect } from 'react'
import { useRecoilState, useSetRecoilState } from 'recoil'

import { MvnoCheckValue } from '@/features/join/store'
import { certCheck, TelTypeState } from '@/shared/store'
import { TelChoiceTabWrap, TelecomBtn } from '@/styles/common/subscript'

const TelChoiceTab = () => {
  const [TelType, setTelType] = useRecoilState(TelTypeState)
  const [CertCheck, setCertCheck] = useRecoilState(certCheck)
  const setMvnoCheckValue = useSetRecoilState(MvnoCheckValue)
  const TelTabOption = [
    { idx: 0, text: 'SKT', borderRadius: '10px 0 0 10px' },
    { idx: 1, text: 'KT', borderRadius: '0' },
    { idx: 2, text: 'LG U+', borderRadius: '0 10px 10px 0' },
  ]

  useEffect(() => {
    return () => {
      setTelType(0)
      setCertCheck(false)
      setMvnoCheckValue(false)
    }
  }, [setTelType, setCertCheck, setMvnoCheckValue])

  return (
    <TelChoiceTabWrap>
      {TelTabOption.map((option: { text: string; borderRadius: string; idx: number }) => (
        <TelecomBtn
          disabled={CertCheck}
          key={option.text}
          borderRadius={option.borderRadius}
          active={`${option.idx === TelType}`}
          onClick={() => setTelType(option.idx)}
        >
          {option.text}
        </TelecomBtn>
      ))}
    </TelChoiceTabWrap>
  )
}
export default TelChoiceTab
